import { Card, Form, Input } from 'antd';
import { EditLayout } from 'components/layout/layout/EditLayout';
import { ILibrary } from 'interfaces/libraries';
import { PageHeader } from 'components/professor_area/PageHeader';
import { PlayCircleOutlined } from '@ant-design/icons';
import { useCan } from '@refinedev/core';
import { useForm } from '@refinedev/antd';
import { useParams } from 'react-router-dom';

export const LibrariesEdit = () => {
  const { id } = useParams();
  const { data: canEdit } = useCan({
    resource: 'libraries',
    action: 'edit'
  });
  const hasEditPermission = !!canEdit?.can;

  const { formProps } = useForm<ILibrary>({
    resource: 'prometheus/v2/libraries',
    id,
    action: 'edit',
    queryOptions: {
      enabled: !!id && hasEditPermission
    },
    redirect: false,
    autoSave: {
      enabled: true,
      debounce: 1000
    }
  });

  if (!hasEditPermission) {
    return null;
  }

  return (
    <EditLayout>
      <PageHeader
        title={formProps.initialValues?.name}
        icon={PlayCircleOutlined}
      />

      <Card>
        <Form {...formProps} layout="vertical">
          <Form.Item
            label="Nome"
            name="name"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Card>
    </EditLayout>
  );
};
